import React, { useState, useEffect } from "react";
import { CartStackedProduct } from "../CartStackedProduct";
import useCartData from "@arctheme-hooks/useCartData";

export const StackedLayout = ({ settings }) => {
  const { section, routes } = settings;
  const {cart, fetchCart}: any = useCartData();
  const [cartItems, setCartItems]: any = useState([]);
  const productLayout = section.product_layout;
  const useSubscriptions = false;
  const showTitles = false;

  useEffect(() => {
    if (fetchCart) {
      fetchCart();
    }
  }, []);

  useEffect(() => {
    if (cart?.items && cart.items !== cartItems) {
      setCartItems(cart.items);
    }
  }, [cart, cartItems]);

  const subscriptionProducts = React.useMemo(
    () => cartItems.filter((item) => item.selling_plan_allocation),
    [cartItems]
  );
  
  const oneTimeProducts = React.useMemo(
    () => cartItems.filter((item) => !item.selling_plan_allocation),
    [cartItems]
  );

  return (
    <div className={`flex flex-col gap-4 lg:gap-y-[48px]`}>
      {oneTimeProducts?.length > 0 && (
        <div className="flex-col flex gap-y-4">
          {showTitles && <p className={`text-sm lg:text-2xl font-medium`}>One time purchase</p>}
          {oneTimeProducts?.map((item, index) => (
            <React.Fragment key={index}>
              <CartStackedProduct item={item} settings={settings} />
            </React.Fragment>
          ))}
        </div>
      )}
      {subscriptionProducts.length > 0 && (
        <div className="flex-col flex gap-y-4">
          {showTitles &&  <p className={`text-sm lg:text-2xl font-medium`}>Subscription products</p>}
          {subscriptionProducts.map((item, index) => (
            <React.Fragment key={index}>
              <CartStackedProduct item={item} settings={settings} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
